import trend from 'jquery-trend';
import themeUtils from '../themeUtils';
import StaticNavigation from './StaticNavigation';

export default class StaticHeader {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.$window = $(window);
    this.$body = $(document.body);
    this.$header = this.$el.find('[data-section-type="header"]');

    this.$mainHeader = this.$el.find('[data-header-main]');
    this.$headerContent = this.$el.find('[data-header-content]');
    this.$navigationWrapper = this.$el.find('[data-navigation-wrapper]');
    this.$navigationContent = this.$el.find('[data-navigation-content]');
    this.$branding = this.$el.find('[data-header-branding]');
    this.$headerTools = this.$el.find('.header-tools');

    this.$headerRight = this.$el.find('[data-header-content-right]');
    this.$headerSearch = this.$el.find('[data-header-search]');
    this.$headerSearchSubmit = this.$el.find('[data-header-search-button]');
    this.$headerSearchClose = this.$el.find('[data-header-search-button-close]');

    this.cachedHeight = 0;
    this.cachedStickyHeight = 0;
    this.isCacheStale = true;

    this.isStickyHeader = section.data.stickyHeader;
    this.isCompactCenter = section.data.compactCenter === 'compact-center';
    this.navHeight = 0;
    this.windowWidth = themeUtils.windowWidth();
    setTimeout(() => {
      this.navHeight = this.$navigationWrapper.height();
    },
    100);
    this.navigation = new StaticNavigation(this.el);
    this._setSearchWidth();
    this._setupBranding();
    this._setCompactCenterHeights();
    this._toggleStickyHeader(this._shouldHeaderStick());

    this._bindEvents();
  }

  onSectionDeselect() {
    this.navigation.toggleMobileNavigation('close');
  }

  onSectionUnload() {
    this.unload();
  }

  unload() {
    this.navigation.unload();
    this.$window.off('.header');
    this.$headerSearchSubmit.off('.header-search');
    this.$headerSearchClose.off('.header-search');

    this._toggleStickyHeader(this._shouldHeaderStick());
  }

  _bindEvents() {
    this.$window.on('resize.header', () => {
      // Prevent resize caused by iOS viewport change
      if (themeUtils.windowWidth() === this.windowWidth) { return; }
      this.windowWidth = themeUtils.windowWidth();

      this.navHeight = this.$navigationWrapper.height();

      this.isCacheStale = true;

      this._toggleStickyHeader(this._shouldHeaderStick());
      this._setSearchWidth();
      this._setCompactCenterHeights();

      if (!themeUtils.isLessThanLarge()) {
        this._toggleSearchForm(false);
      }
    });

    this.$window.on('scroll.header', () => {
      // Only calculate heights on scroll if sticky header is disabled
      if (!this.isStickyHeader) {
        this._setCompactCenterHeights();
      }

      // Sticky header calculates heights
      this._toggleStickyHeader(this._shouldHeaderStick());
    });

    this.$headerSearchSubmit.on('click.header-search', (event) => {
      const $target = $(event.currentTarget);

      if (!themeUtils.isLessThanLarge()) { return; }
      if ($target.data('clicked')) { return; }

      event.preventDefault();
      $target.data('clicked', true);
      this._bindCloseSearch();
      this._toggleSearchForm(true);
    });

    this.$headerSearchClose.on('click.header-search', (event) => {
      event.preventDefault();
      this._toggleSearchForm(false);
    });
  }

  /*
        When search form is open, and receives click outside of form, close
        */
  _bindCloseSearch() {
    this.$body.on('click.header-search-close', (event), () => {
      const $parent = $(event.target).parents('[data-header-search]');
      if ($parent.length) { return; }

      this._toggleSearchForm(false);
    });
  }

  _shouldHeaderStick() {
    let shouldStick = false;

    if (!this.isStickyHeader) {
      return shouldStick;
    }

    if (this.isCacheStale) {
      let height = this.$body.hasClass('sticky-header') ? 0 : this.$headerContent.outerHeight(true);
      let stickyHeight = this.$body.hasClass('sticky-header') ? this.$headerContent.outerHeight(true) : 0;

      this.$body.toggleClass('sticky-header');

      height = !this.$body.hasClass('sticky-header') ? this.$headerContent.outerHeight(true) : height;
      stickyHeight = !this.$body.hasClass('sticky-header') ? stickyHeight : this.$headerContent.outerHeight(true);

      this.$body.toggleClass('sticky-header');

      this.cachedHeight = height;
      this.cachedStickyHeight = stickyHeight;
      this.isCacheStale = false;
    }

    if (this.$window.scrollTop() > ((this.$headerTools.outerHeight() + this.cachedHeight) - this.cachedStickyHeight)) {
      shouldStick = true;
    }

    if (themeUtils.isLessThanLarge() || this.$body.hasClass('alternate-index-layout')) {
      shouldStick = false;
    }

    return shouldStick;
  }

  _toggleStickyHeader(toggleOn) {
    let paddingBottom;
    if (toggleOn == null) { toggleOn = false; }
    if (toggleOn && !this.$body.hasClass('sticky-header')) {
      paddingBottom = this.cachedHeight;
      this.$mainHeader.css({ paddingBottom });
    }

    if (!toggleOn) {
      paddingBottom = 0;
      this.$mainHeader.css({ paddingBottom });
    }

    if (toggleOn !== this.$body.hasClass('sticky-header')) {
      this.$body.toggleClass('sticky-header', toggleOn);
      this._setCompactCenterHeights(!toggleOn);
    }
  }

  /*
        Expand search form logic
        */
  _toggleSearchForm(open) {
    if (open == null) { open = false; }
    let headerRightWidth = '';
    let headerSearchWidth = parseInt(this.$headerSearch.data('width'), 10);
    const searchButtonWidth = this.$headerSearchClose.outerWidth(true);
    let logoCollision = false;
    let navCollision = false;

    if (open) {
      ({ logoCollision, navCollision } = this._logoSearchCollision(headerSearchWidth));
      headerRightWidth = headerSearchWidth + searchButtonWidth;
      headerSearchWidth = '100%';
    } else {
      this.$headerSearchSubmit.data('clicked', false);
      this.$body.off('.header-search-close');
    }

    if (!open && this.$mainHeader.hasClass('header-search-expanded')) {
      this.$mainHeader.addClass('header-search-expanded-closing', true);
    }

    this.$mainHeader.toggleClass('header-search-expanded', open);
    this.$mainHeader.toggleClass('header-nav-toggle-covered', navCollision);
    this.$mainHeader.toggleClass('header-logo-covered', logoCollision).one('trend', () => {
      if (!open) {
        this.$mainHeader.removeClass('header-search-expanded-closing');
      }
    });

    this.$headerRight.css({ width: headerRightWidth });
    this.$headerSearch.css({ width: headerSearchWidth });
  }

  /*
        Detect if Logo or nav toggle will be covered by expanded search form
        */
  _logoSearchCollision(headerSearchWidth) {
    const logoRightEdge = document.querySelector('[data-header-branding] .logo-link').getBoundingClientRect().right;
    const navRightEdge = document.querySelector('[data-header-content] [data-header-nav-toggle]').getBoundingClientRect().right;

    const searchLeftEdge = document.querySelector('[data-header-search]').getBoundingClientRect().left - headerSearchWidth;

    const logoCollision = logoRightEdge > searchLeftEdge;
    const navCollision = navRightEdge > searchLeftEdge;

    return {
      logoCollision,
      navCollision,
    };
  }

  /*
        Match Navigation and Branding heights
        Center navigation vertically if Branding is taller
        */
  _setCompactCenterHeights(toggleOn) {
    if (toggleOn == null) { toggleOn = true; }
    if (!this.isCompactCenter) { return; }

    let minHeight = 'auto';

    // Get height of inner navigation to prevent height locking on two row navigation
    const navHeight = this.$navigationContent.outerHeight(true);
    let navOffset = 0;

    if (!themeUtils.isLessThanLarge() && toggleOn) {
      const heights = [];
      heights.push(navHeight);
      heights.push(this.$branding.outerHeight(true));

      minHeight = Math.max.apply(null, heights);
    }

    if (navHeight < minHeight) {
      navOffset = (minHeight - navHeight) / 2;
    }

    this.navHeight = this.$navigationWrapper.outerHeight(true);

    this.$navigationWrapper.css('margin-top', navOffset);
    this.$headerContent.css({ minHeight });
  }

  _setupBranding() {
    // Clone desktop branding to mobile
    const $mobileBranding = this.$branding.clone();
    $mobileBranding
      .removeAttr('data-header-branding')
      .removeClass('header-branding-desktop')
      .addClass('header-branding-mobile');

    this.$navigationContent.prepend($mobileBranding);
  }

  _setSearchWidth() {
    const searchWidth = this.$mainHeader.find('.mini-cart-wrapper').outerWidth(true)
      + this.$mainHeader.find('.checkout-link').outerWidth(true);

    this.$headerSearch.width(searchWidth);
    return this.$headerSearch.data('width', searchWidth);
  }
}
